import { styled, Text } from '@erecruit/ui-kit';

export const Disclaimer = styled(Text)`
  padding-bottom: 32px;
`;
